export const SUPER_CATEGORY_ORDER = ['MARKETING', 'SALES', 'CUSTOMER_SERVICE', 'PRODUCTIVITY', 'FINANCE', 'COMMERCE'];